/**
 * <OptionCardSkeleton> — la forme d'une `<OptionCard>` pendant un chargement.
 *
 * La carte et son contour (`optionCardContour`, non choisi), la pastille de tête quand l'option en porte une
 * (le visage d'un tuteur), le libellé et sa ligne de contexte. Posé par les étapes qui attendent
 * leurs options — les créneaux de rattrapage, les modes de cours du composeur.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { Card } from "../Card"
import { optionCardContour } from "./OptionCard"

export type OptionCardSkeletonProps = {
    /** Le diamètre de la pastille de tête — absent, l'option n'en a pas. */
    leadingSize?: number
    /** La barre du libellé, en px. */
    labelWidth?: number
    /** La barre de la ligne de contexte, en px — `null` : l'option n'en a pas. */
    descriptionWidth?: number | null
}

export function OptionCardSkeleton(props: OptionCardSkeletonProps) {
    const { leadingSize, labelWidth = 170, descriptionWidth = 120 } = props

    return (
        <Card p="3" style={optionCardContour.card(false)}>
            <Row gap="3" align="center">
                {leadingSize != null && <Skeleton shape="circle" size={leadingSize} />}
                <Stack gap="1" style={styles.body}>
                    <Skeleton textSize="text-base" width={labelWidth} />
                    {descriptionWidth != null && <Skeleton textSize="text-sm" width={descriptionWidth} />}
                </Stack>
            </Row>
        </Card>
    )
}

const styles = StyleSheet.create(() => ({
    body: { flexShrink: 1, flexGrow: 1 },
}))
